var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableContext',_vm._b({},'TableContext',_vm.$attrs,false),[_c('span',{staticClass:"capacity-icon",on:{"click":_vm.onCapacityClicked}},[_vm._v("C")])])
}
var staticRenderFns = []

export { render, staticRenderFns }